// extracted by mini-css-extract-plugin
module.exports = {"shoppingCenterListWrapper":"_1OwFnA1MwLmR3rfBcaxZPo"};